import { getBoardBasisCode } from 'utils/utils';
import { updateBoardBasisFilter, updateReturnDateFilter, deleteFilters } from './flightFiltersActions';
import { CALL_API } from '../middleware/api';

export const TYPES = {
  LOADING_START_SPINNER: 'LOADING_START_SPINNER',
  LOADING_START: 'LOADING_START',
  LOADING_FINISH: 'LOADING_FINISH',
  UPDATE_SELECTED_OFFER_OF_DAY: 'UPDATE_SELECTED_OFFER_OF_DAY',
  SET_PAGE_SCROLL_Y: 'SET_PAGE_SCROLL_Y',
  DELETE_PAGE_SCROLL_Y: 'DELETE_PAGE_SCROLL_Y',
  ERROR_FIELD: 'ERROR_FIELD',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  SET_SEARCH_RESULTS_TRACKING_FLAG: 'SET_SEARCH_RESULTS_TRACKING_FLAG',
  PANDA_SEARCH_FORM_TOGGLE: 'PANDA_SEARCH_FORM_TOGGLE',
  SET_DURATION: 'SET_DURATION',
  SET_NON_DIMENSION_DURATION: 'SET_NON_DIMENSION_DURATION',
  SET_NON_DIMENSION_NUMBER_OF_NIGHTS: 'SET_NON_DIMENSION_NUMBER_OF_NIGHTS',
  SET_VIEWPORT_DIMENSIONS: 'SET_VIEWPORT_DIMENSIONS',
  SHOW_HO_FLIGHT_UPSELL: 'SHOW_HO_FLIGHT_UPSELL',
  SET_DESTINATION_QUERY: 'SET_DESTINATION_QUERY',
  SET_HOTEL_QUERY: 'SET_HOTEL_QUERY',
  SET_DEPARTURE_QUERY: 'SET_DEPARTURE_QUERY',
  SET_HAS_NO_DESTINATION_RESULTS: 'SET_HAS_NO_DESTINATION_RESULTS',
  SET_HAS_NO_HOTEL_RESULTS: 'SET_HAS_NO_HOTEL_RESULTS',
  LANDLINE_PHONE_REQUEST: 'LANDLINE_PHONE_REQUEST',
  LANDLINE_PHONE_SUCCESS: 'LANDLINE_PHONE_SUCCESS',
  LANDLINE_PHONE_FAILURE: 'LANDLINE_PHONE_FAILURE',
  HIDE_LANDLINE_PHONE: 'HIDE_LANDLINE_PHONE',
  SET_LHX_PROPERTY: 'SET_LHX_PROPERTY',
  SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO: 'SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO',
};

export const setLandlinePhone = () => ({
  [CALL_API]: {
    types: [
      TYPES.LANDLINE_PHONE_REQUEST,
      TYPES.LANDLINE_PHONE_SUCCESS,
      TYPES.LANDLINE_PHONE_FAILURE,
    ],
    endpoint: '/api/channel',
  },
});

/* istanbul ignore next */
export const errorField = field => ({
  type: TYPES.ERROR_FIELD,
  field,
});

/* istanbul ignore next */
export const clearErrors = () => ({
  type: TYPES.CLEAR_ERRORS,
});

export const loadingStart = (key = 'loadingState') => ({
  type: TYPES.LOADING_START_SPINNER,
  key,
});

export const loadingFinish = (key = 'loadingState') => ({
  type: TYPES.LOADING_FINISH,
  key,
});

/* istanbul ignore next */
export const loadingStartDelayedSpinner = () => (dispatch, getState) => {
  setTimeout(() => {
    if (getState().appState.get('loadingState')) {
      dispatch(loadingStart());
    }
  }, 1000);

  dispatch({
    type: TYPES.LOADING_START,
  });
};

/* istanbul ignore next */
export const bridgeDataLoaded = () => (dispatch, getState) => {
  const offer = getState().appState.get('selectedOffer');
  if (offer) {
    dispatch(deleteFilters());
    const selectedBoardBasis = getState().baseState.get('D_BoardBasis');
    if (selectedBoardBasis) {
      selectedBoardBasis.forEach(value => dispatch(updateBoardBasisFilter(
        getBoardBasisCode(getState().dimensionsEntities.getIn([String(value), 'id'])), true,
      )));
    }
    dispatch(updateReturnDateFilter(offer.get('returnDepartureDate')));
  }
};

export const updateSelectedOfferOfDay = offer => ({
  type: TYPES.UPDATE_SELECTED_OFFER_OF_DAY,
  offer,
});

export const setPageScrollY = pageScrollY => ({
  type: TYPES.SET_PAGE_SCROLL_Y,
  pageScrollY,
});

export const deletePageScrollY = () => ({
  type: TYPES.DELETE_PAGE_SCROLL_Y,
});

export const setSearchResultsTrackingFlag = flag => ({
  type: TYPES.SET_SEARCH_RESULTS_TRACKING_FLAG,
  flag,
});

export const pandaSearchFormToggle = flag => ({
  type: TYPES.PANDA_SEARCH_FORM_TOGGLE,
  flag,
});

export const setDuration = addDimId => ({
  type: TYPES.SET_DURATION,
  addDimId,
});

export const setHotelQuery = hotelQuery => ({
  type: TYPES.SET_HOTEL_QUERY,
  hotelQuery,
});

export const setDestinationQuery = destinationQuery => ({
  type: TYPES.SET_DESTINATION_QUERY,
  destinationQuery,
});

export const setDepartureAirportQuery = departureAirportQuery => ({
  type: TYPES.SET_DEPARTURE_QUERY,
  departureAirportQuery,
});

export const setNonDimensionDuration = numberOfNights => ({
  type: TYPES.SET_NON_DIMENSION_DURATION,
  numberOfNights,
});

export const setNonDimensionNumberOfNights = numberOfNights => ({
  type: TYPES.SET_NON_DIMENSION_NUMBER_OF_NIGHTS,
  numberOfNights,
});

export const setViewportDimensions = (viewportDimensions, isMobileBreakpoint) => ({
  type: TYPES.SET_VIEWPORT_DIMENSIONS,
  viewportDimensions,
  isMobileBreakpoint,
});

export const showHOFlightUpsell = show => ({
  type: TYPES.SHOW_HO_FLIGHT_UPSELL,
  show,
});

export const setHasNoDestinationResults = hasNoDestinationResults => ({
  type: TYPES.SET_HAS_NO_DESTINATION_RESULTS,
  hasNoDestinationResults,
});

export const setHasNoHotelResults = hasNoHotelResults => ({
  type: TYPES.SET_HAS_NO_HOTEL_RESULTS,
  hasNoHotelResults,
});

export const setReasonToHideLandlinePhone = reasons => ({
  type: TYPES.HIDE_LANDLINE_PHONE,
  reasons,
});

export function setLHXProperty(property, value) {
  return {
    type: TYPES.SET_LHX_PROPERTY,
    property,
    value,
  };
}

export const setHasThirdPartyChannelParamHO = isThirdPartyChannelParam => ({
  type: TYPES.SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO,
  isThirdPartyChannelParam,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/appStateActions.js
 **/